export default "/images/vendor/flag-icon-css/flags/4x3/ke.svg?785c24b7349ff3963bf934c2741409fe";